import { IPendingPayment } from "interfaces";
import { abbreviateNumbers, currencySymbol, formatNumber, getPaymentMethodLabel } from "utills/helpers";

interface PendingPaymentCardProps {
  data?: IPendingPayment[];
  isLoading: boolean;
}

export const PendingPaymentCard = ({data = [] }: PendingPaymentCardProps) => {

  return (
    <ul className="bg-white">
      {data.map((item: IPendingPayment, index: number) => (
        <div key={index} className="flex flex-col gap-y-4 overflow-hidden shadow-md ring-1 ring-gray-900/5 [&:not(:last-child)]:mb-4 p-4 rounded-xl">
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              No
            </p>
            <p className="flex-1 text-right text-sm leading-6">{index + 1}</p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Payment method 
            </p>
            <p className="flex-1 text-right text-sm leading-6">{getPaymentMethodLabel(item.payment_method)}</p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Total orders
            </p>
            <p 
              className="flex-1 text-right text-sm leading-6"
              data-tooltip-id="tooltip"
              data-tooltip-content={formatNumber(item.total_order)}
            >
              {abbreviateNumbers(item.total_order)}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Gross revenue
            </p>
            <p 
              className="flex-1 text-right text-sm leading-6"
              data-tooltip-id="tooltip"
              data-tooltip-content={formatNumber(item.gross_revenue)}
            >
              {currencySymbol()} {abbreviateNumbers(item.gross_revenue)}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Net revenue
            </p>
            <p 
              className="flex-1 text-right text-sm leading-6"
              data-tooltip-id="tooltip"
              data-tooltip-content={formatNumber(item.net_revenue)}
            >
              {currencySymbol()} {abbreviateNumbers(item.net_revenue)}
            </p>
          </li>
        </div>
      ))}
    </ul>
  )
}